export const types = {
  SET_LOADING: 'SET_LOADING',
  SET_DELIVERY_NUMBER: 'SET_DELIVERY_NUMBER',
  SET_PRODUCTS: 'SET_PRODUCTS,',
  UPDATE_PRODUCT: 'UPDATE_PRODUCT',
  ADD_PRODUCT: 'ADD_PRODUCT',
  REMOVE_PRODUCT: 'REMOVE_PRODUCT',
  COPY_ADDITIONAL_PRODUCT: 'COPY_ADDITIONAL_PRODUCT',
  RESET_PRODUCT: 'RESET_PRODUCT',
  RESET: 'RESET',
  REMOVE_ADDITIONAL_PRODUCT: 'REMOVE_ADDITIONAL_PRODUCT',
};
